import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  AdriaticInfoModalStyles,
  CloseButton,
  LeftSide,
  ModalBody,
  ModalContent,
  ModalHeader,
  PreContractPill,
  RightSide,
  TextContainer,
  TitleBox,
} from './AdriaticInfoModal.styles';
import preContractIcon from '../../../../assets/redesign_icons/pre-contract-icon.svg';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';
import { downloadResourceDocs } from '../../../../services/axios-client/axeCommons';

function AmtrustInfoModal({ quotation, setShowModal }) {
  const closeModal = () => setShowModal(false);

  return (
    <AdriaticInfoModalStyles>
      <ModalBody>
        <ModalHeader>
          <LeftSide>
            <TextContainer>
              <TitleBox>
                <img src={infoIcon} alt="" />
                <h3>Informazione</h3>
              </TitleBox>
              <p>Qui puoi controllare le informazioni su questa offerta AmTrust.</p>
            </TextContainer>
          </LeftSide>

          <RightSide>
            {(() => {
              const docMapping = {
                medici_dipendenti: 25,
                medici_liberi_professionisti: 27,
                medico_protetto: 26,
                professioni_sanitarie: 24,
              };

              let docId = docMapping[quotation?.sub_product];

              if (quotation?.product_id === 1000) {
                docId = 42;
              }

              if (!docId) return null;

              return (
                <PreContractPill
                  onClick={() => downloadResourceDocs(docId, 0)}
                  title="Informativa Precontrattuale"
                >
                  <img src={preContractIcon} alt="" />
                  <p>Informativa Precontrattuale</p>
                </PreContractPill>
              );
            })()}
          </RightSide>
          <CloseButton onClick={closeModal} aria-label="Chiudi">
            <FontAwesomeIcon icon={faTimes} />
          </CloseButton>
        </ModalHeader>

        <ModalContent>
          {quotation?.product_id === 1000 ? (
            <div className="card-extra-information">
              <h3>Informazioni Polizza Dipendenti Pubblica Amministrazione</h3>

              <p>
                <b>Tipo di assicurazione:</b>
                {' '}
                Copertura per Responsabilità Amministrativa e Amministrativo/Contabile (Sezione A),
                con possibilità di estensioni opzionali Tutela Legale (Sezione B) e Infortuni (Sezione C). La Sezione A opera in
                regime Claims Made, le Sezioni B e C in regime Loss Occurrence.
              </p>

              <p>
                <b>Cosa è assicurato:</b>
                {' '}
                Responsabilità amministrativa e contabile per colpa grave accertata, danni materiali,
                ultrattività e coperture aggiuntive opzionali Tutela Legale e Infortuni. Massimali: Sezione A da €500.000 a €6.000.000,
                Sezione B €100.000, Sezione C €50.000.
              </p>

              <p>
                <b>Cosa non è assicurato:</b>
                {' '}
                Atti dolosi, responsabilità volontarie al di fuori dei compiti d’ufficio, responsabilità
                professionale sanitaria, attività di partito o sindacali, sanzioni pecuniarie e altre esclusioni specifiche.
              </p>

              <p>
                <b>Dove vale la copertura:</b>
                {' '}
                Sezione A in Europa (con pretese legali in Italia), Sezione B sinistri in Europa e Italia,
                Sezione C mondo intero.
              </p>

              <p>
                <b>Obblighi:</b>
                {' '}
                Dichiarazioni veritiere, comunicazione di variazioni del rischio, tempestiva denuncia dei sinistri,
                non ammettere responsabilità senza consenso della compagnia, esercizio dei diritti entro 2 anni.
              </p>

              <p>
                <b>Pagamento e durata:</b>
                {' '}
                Premio entro 15 giorni dalla decorrenza. Copertura annuale con tacito rinnovo,
                possibilità di recesso e diritto di ripensamento entro 14 giorni.
              </p>
            </div>
          ) : quotation?.sub_product === 'professioni_sanitarie' ? (
            <div className="card-extra-information">
              <h3>Informazioni Polizza Professionisti Sanitari</h3>

              <p>
                <b>Tipo di assicurazione:</b>
                {' '}
                Polizza dedicata ai Professionisti Sanitari non Medici iscritti all’Albo professionale,
                che copre i danni causati a terzi nello svolgimento dell’attività professionale. La polizza opera nella forma Claims Made.
              </p>

              <p>
                <b>Cosa è assicurato:</b>
                {' '}
                Patrimonio dell’Assicurato per danni a persone, morte o danni materiali a cose, conseguenti a colpa,
                errori o omissioni professionali. Garanzie aggiuntive opzionali: Medical Device e Perdite Patrimoniali. Operano entro i massimali previsti.
              </p>

              <p>
                <b>Cosa non è assicurato:</b>
                {' '}
                Non sono considerati terzi coniuge, convivente, genitori, figli o altri parenti conviventi.
                Esclusioni: interventi di medicina estetica, danni da radiazioni o farmaci non terapeutici, violazioni del segreto professionale,
                diffamazione, cyber risk e discriminazioni.
              </p>

              <p>
                <b>Limiti di copertura:</b>
                {' '}
                In caso di responsabilità solidale, la compagnia risponde per l’intero salvo diritto di regresso.
                Solo le categorie di rischio indicate nella Scheda di Polizza sono coperte.
              </p>

              <p>
                <b>Dove vale la copertura:</b>
                {' '}
                Richieste di risarcimento originate da fatti dannosi in tutto il mondo, esclusi USA, Canada e territori sotto la loro giurisdizione.
                L’Assicurato deve avere residenza in Italia.
              </p>

              <p>
                <b>Obblighi:</b>
                {' '}
                Dichiarazioni veritiere sul rischio, comunicazione di cambiamenti, tempestiva denuncia dei sinistri,
                consenso della compagnia prima di ammettere responsabilità, regolazione del premio Ultrattività e rispetto dei termini di legge per far valere i diritti (entro 2 anni).
              </p>

              <p>
                <b>Pagamento e durata:</b>
                {' '}
                Premio da pagare prima della decorrenza, annuale con tacito rinnovo. Possibile frazionamento semestrale,
                pagamento Ultrattività in unica soluzione. Pagamenti tramite contante, assegno, bonifico o sistemi elettronici.
              </p>

              <p>
                <b>Decorrenza e scadenza:</b>
                {' '}
                Copertura dalle ore 24.00 del giorno indicato nella Scheda di Polizza. Tacito rinnovo salvo disdetta 30 giorni prima della scadenza annuale.
              </p>
            </div>
          ) : quotation?.sub_product === 'medici_dipendenti' ? (
            <div className="card-extra-information">
              <h3>Informazioni Polizza Medici Dipendenti</h3>
              <p>
                <b>Tipo di assicurazione:</b>
                {' '}
                Polizza dedicata ai Medici Dipendenti o Specializzandi iscritti all’Albo professionale,
                che copre i danni causati nello svolgimento dell’Attività Assicurata. La polizza opera nella forma Claims Made.
              </p>
              <p>
                <b>Cosa è assicurato:</b>
                {' '}
                Patrimonio dell’Assicurato per danni a terzi per colpa grave già risarciti dalla Struttura o dalla compagnia,
                garanzie base e opzionali acquistabili a seconda del ruolo e attività (Dipendente Pubblico Base I, Privato Base II, Ruolo apicale, Perdite Patrimoniali, Ultrattività, Attività accessorie, ecc.).
              </p>
              <p>
                <b>Cosa non è assicurato:</b>
                {' '}
                Non sono considerati terzi coniuge, convivente, genitori, figli o altri parenti conviventi. Esclusioni: trattamenti di medicina e chirurgia estetica, furto, incendio, esplosione o scoppio.
              </p>
              <p>
                <b>Limiti di copertura:</b>
                {' '}
                Responsabilità solidale con altri, solo categorie di rischio indicate nella sezione Dati del Rischio.
              </p>
              <p>
                <b>Dove vale la copertura:</b>
                {' '}
                Richieste originate da fatti dannosi ovunque l’Assicurato eserciti su incarico della Struttura italiana, esclusi USA, Canada e territori sotto la loro giurisdizione.
                Residenza o domicilio professionale in Italia.
              </p>
              <p>
                <b>Obblighi:</b>
                {' '}
                Dichiarazioni veritiere, comunicazione di cambiamenti, tempestiva denuncia dei sinistri, consenso della compagnia prima di ammettere responsabilità, regolazione del premio Ultrattività, comunicazione di sospensione, radiazione o licenziamento, esercizio dei diritti entro 2 anni.
              </p>
              <p>
                <b>Pagamento e durata:</b>
                {' '}
                Premio annuo o frazionato, inclusivo di imposte. Tacito rinnovo salvo disdetta. Premio Ultrattività in unica soluzione. Pagamenti tramite contante, assegno, bonifico o sistemi elettronici.
              </p>
              <p>
                <b>Decorrenza e scadenza:</b>
                {' '}
                Copertura dalle ore 24.00 del giorno indicato nella Scheda di Polizza. Tacito rinnovo salvo disdetta 30 giorni prima della scadenza annuale.
              </p>
              <p>
                <b>Disdetta e recesso:</b>
                {' '}
                Possibile con preavviso 30 giorni prima della scadenza, recesso dopo sinistro entro 60 giorni, diritto di ripensamento 14 giorni per Vendita a Distanza.
              </p>
            </div>
          ) : quotation?.sub_product === 'medico_protetto' ? (
            <div className="card-extra-information">
              <h3>Informazioni Polizza Medico Protetto</h3>
              <p>
                AmTrust Assicurazioni S.p.A. appartiene al gruppo AmTrust, la cui capogruppo è la società statunitense AmTrust Financial Services, Inc. (AFSI). La sede legale è in Via Clerici, 14 – 20121 Milano (MI). Le informazioni precontrattuali e contrattuali complete sono fornite in altri documenti.
              </p>
              <p>
                <b>Tipo di assicurazione:</b>
                {' '}
                Questa polizza assicura il medico esercente attività libero professionale con particolare protezione (“Medico Protetto”), iscritto all’Albo Professionale del relativo Ordine e/o in possesso dei titoli e abilitazioni richieste dalla legge per l’esercizio dell’attività. L’Assicurazione opera in forma
              </p>
              <p>
                <b>Claims Made</b>
                {' '}
                , ossia copre le Richieste di Risarcimento ricevute per la prima volta durante il Periodo di Assicurazione e denunciate entro 30 giorni dalla scadenza, purché conseguenti a fatti colposi, errori od omissioni accaduti dopo la Data di Retroattività.
              </p>
              <p>
                <b>Cosa è assicurato:</b>
                {' '}
                La Società tiene indenne il medico Assicurato di quanto questi sia tenuto a pagare per danni causati a terzi nello svolgimento dell’Attività Assicurata. Sono previste garanzie opzionali come Medicina estetica, Attività invasive minori, Ruolo apicale – Perdite Patrimoniali e Ultrattività, secondo quanto indicato nella Scheda di Polizza.
              </p>
              <p>
                <b>Cosa non è assicurato:</b>
                {' '}
                Non sono considerati terzi: coniuge, convivente, genitori e figli o altri parenti conviventi. Sono esclusi danni già preesistenti, attività odontoiatriche o implantologiche non coperte, interventi estetici non assicurati e altri casi indicati nelle Condizioni di Assicurazione.
              </p>
              <p>
                <b>Dove vale la copertura:</b>
                {' '}
                Copertura per richieste di risarcimento originate in tutto il mondo, esclusi USA, Canada e territori sotto loro giurisdizione. L’Assicurato deve avere residenza o domicilio professionale in Italia e le richieste devono essere fatte valere in Italia.
              </p>
              <p>
                <b>Obblighi, pagamento e disdetta:</b>
                {' '}
                Dichiarazioni veritiere sul rischio, denuncia tempestiva dei sinistri, pagamento del premio secondo le modalità indicate, tacito rinnovo, disdetta con preavviso di almeno 30 giorni e diritto di ripensamento in caso di vendita a distanza.
              </p>
            </div>
          ) : quotation?.sub_product === 'medici_liberi_professionisti' ? (
            <div className="card-extra-information">
              <h3>Informazioni Polizza Medici Liberi Professionisti</h3>
              <p>
                AmTrust Assicurazioni S.p.A. appartiene al gruppo AmTrust, capogruppo statunitense AmTrust Financial Services, Inc. (AFSI). La sede legale è in Via Clerici, 14 – 20121 Milano (MI). Le informazioni precontrattuali e contrattuali complete sono fornite in altri documenti.
              </p>
              <p>
                <b>Tipo di assicurazione:</b>
                {' '}
                Questa polizza assicura i Medici, iscritti all’Albo professionale, per danni causati a terzi nello svolgimento della propria Attività Professionale. Opera in forma
                <b>Claims Made</b>
                , ossia copre le Richieste di Risarcimento ricevute per la prima volta durante il Periodo di Assicurazione e denunciate entro 30 giorni dalla scadenza, purché conseguenti a fatti colposi, errori od omissioni.
              </p>
              <p>
                <b>Cosa è assicurato:</b>
                {' '}
                Responsabilità civile professionale per danni a terzi. Copertura opzionale per Ultrattività se attivata e pagata. Coperture entro Massimale per Sinistro e Massimale per Periodo di Assicurazione.
              </p>
              <p>
                <b>Cosa non è assicurato:</b>
                {' '}
                Non sono considerati terzi: coniuge, convivente, genitori e figli o altri parenti conviventi. Esclusi danni da attività non assicurata, interventi estetici non coperti, violazione del consenso informato, cyber risk, danni derivanti da consulenze online, tra gli altri casi indicati nelle Condizioni di Assicurazione.
              </p>
              <p>
                <b>Dove vale la copertura:</b>
                {' '}
                Copertura mondiale esclusi USA, Canada e territori sotto loro giurisdizione. L’Assicurato deve avere residenza o domicilio professionale in Italia e le richieste devono essere fatte valere in Italia.
              </p>
              <p>
                <b>Obblighi e pagamento:</b>
                {' '}
                Dichiarazioni veritiere, denuncia tempestiva dei sinistri, pagamento del premio prima della decorrenza, tacito rinnovo, diritto di disdetta con preavviso di 30 giorni e diritto di ripensamento se Vendita a Distanza. Premio aggiuntivo Ultrattività corrisposto in unica soluzione.
              </p>
              <p>
                <b>Decorrenza e scadenza:</b>
                {' '}
                Copertura dalle ore 24.00 della data indicata in polizza o del pagamento del premio, termina alle ore 24.00 del giorno di scadenza indicato. In caso di mancato pagamento del premio di rinnovo o di una rata, l’assicurazione resta sospesa dalle ore 24.00 del trentesimo giorno successivo.
              </p>
            </div>
          ) : null}

        </ModalContent>
      </ModalBody>
    </AdriaticInfoModalStyles>
  );
}

export default AmtrustInfoModal;
